import { Link, useLocation } from "react-router-dom";
import PageShell from "@/components/feature/PageShell";
import { usePageMeta } from "@/hooks/usePageMeta";
import { categories } from "@/mocks/videos";

export default function NotFound() {
  const location = useLocation();
  usePageMeta(
    "页面不存在 - 51视频每日大赛今日黑榜合集",
    "访问的页面不存在，可返回首页浏览最新的赛事黑榜视频，或按分类继续查找。",
  );

  return (
    <PageShell>
      <section className="container-page flex min-h-[calc(100vh-72px)] flex-col items-center justify-center py-16 text-center">
        <p className="font-label text-[80px] font-semibold leading-none text-background-300 md:text-[120px]">404</p>
        <h1 className="mt-4 text-2xl font-bold text-foreground-950 md:text-3xl">这个页面没有找到</h1>
        <p className="mt-3 max-w-md text-sm leading-relaxed text-foreground-600">
          你访问的地址可能已经调整。可以返回首页查看今日更新的黑榜视频，或从下面的分类入口继续浏览。
        </p>
        <p className="mt-2 font-label text-xs tracking-wide text-foreground-400">{location.pathname}</p>

        <div className="mt-6 flex flex-wrap items-center justify-center gap-3">
          <Link to="/" className="btn-primary h-10 px-5">返回首页</Link>
          <Link to="/search" className="btn-ghost h-10 px-5">浏览全部视频</Link>
        </div>

        <div className="mt-8 flex flex-wrap items-center justify-center gap-2">
          {categories.map((category) => (
            <Link
              key={category.id}
              to={`/category/${category.id}`}
              className="chip bg-background-100 text-foreground-700 transition-colors hover:bg-secondary-100 hover:text-secondary-900"
            >
              <i className={`${category.icon} text-sm text-primary-600`} />
              {category.name}
            </Link>
          ))}
        </div>
      </section>
    </PageShell>
  );
}